import { useRouter } from "next/router";
import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useEffect,
  useState
} from "react";

type LoadingProviderProps = {
  children: ReactNode;
};

type LoadingContextData = {
  ActionIsLoading: boolean;
  setActionIsLoading: Dispatch<SetStateAction<boolean>>;
};

export const LoadingContext = createContext({} as LoadingContextData);

export function LoadingProvider({ children }: LoadingProviderProps) {
  const [ActionIsLoading, setActionIsLoading] = useState<boolean>(false);

  const router = useRouter();

  useEffect(() => {
    const handleStart = () => {
      setActionIsLoading(true);
    };
    const handleStop = () => {
      setActionIsLoading(false);
    };
    router.events.on("routeChangeStart", handleStart);

    router.events.on("routeChangeComplete", handleStop);

    router.events.on("routeChangeError", handleStop);
  }, [router]);

  return (
    <LoadingContext.Provider
      value={{
        ActionIsLoading,
        setActionIsLoading
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
}

export function useLoading(): LoadingContextData {
  const context = useContext(LoadingContext);
  return context;
}
